import { useFeatureIsOn } from '@growthbook/growthbook-react';
import CheckoutLayout from '@common/components/CheckoutLayout';
import { GeneralLayoutVersion } from '@common/components/GeneralLayout';
import type { LayoutProps } from '@common/components/GeneralLayout/GeneralLayout';

export function CheckoutLayoutVersion(props: LayoutProps) {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <GeneralLayoutVersion {...props} />;
  return <CheckoutLayout {...props} />;
}
